import React from 'react';
import { 
  Home, 
  Tv, 
  Film, 
  Layers, 
  Search,
  Radio 
} from 'lucide-react';
import { DeviceMode } from '../types';

interface BottomNavProps {
  currentView: string;
  onNavigate: (view: string) => void;
  onOpenSearch: () => void;
  collectionsCount?: number;
  deviceMode: DeviceMode;
  onToggleTvMode: () => void;
}

export const BottomNav: React.FC<BottomNavProps> = ({
  currentView,
  onNavigate,
  onOpenSearch,
  collectionsCount = 0
}) => {
  return (
    <div 
      id="mobile-bottom-navigation"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#070b14]/95 backdrop-blur-xl border-t border-white/10 px-1 pt-2 pb-safe shadow-[0_-10px_30px_rgba(0,0,0,0.8)]"
    >
      <div className="grid grid-cols-6 items-center justify-items-center">
        
        {/* 1. Inici */}
        <button
          id="mobile-tab-home"
          onClick={() => onNavigate('home')}
          className={`flex flex-col items-center justify-center py-1.5 px-1 rounded-xl transition-all ${
            currentView === 'home' 
              ? 'text-sky-400 font-bold scale-105' 
              : 'text-slate-400 hover:text-slate-200'
          }`}
        >
          <Home className="w-4 h-4 mb-0.5" />
          <span className="text-[9px] tracking-tight">Inici</span>
        </button>

        {/* 2. Col·leccions */}
        <button
          id="mobile-tab-collections"
          onClick={() => onNavigate('collections')}
          className={`relative flex flex-col items-center justify-center py-1.5 px-1 rounded-xl transition-all ${
            currentView === 'collections' 
              ? 'text-sky-400 font-bold scale-105' 
              : 'text-slate-400 hover:text-slate-200'
          }`}
        >
          <Layers className="w-4 h-4 mb-0.5" />
          <span className="text-[9px] tracking-tight">Llistes</span>
          {collectionsCount > 0 && (
            <span className="absolute top-1 right-1.5 w-1.5 h-1.5 rounded-full bg-sky-400 animate-pulse" />
          )}
        </button>

        {/* 3. Sèries */}
        <button
          id="mobile-tab-series"
          onClick={() => onNavigate('series')}
          className={`flex flex-col items-center justify-center py-1.5 px-1 rounded-xl transition-all ${
            currentView === 'series' 
              ? 'text-blue-400 font-bold scale-105' 
              : 'text-slate-400 hover:text-slate-200'
          }`}
        >
          <Tv className="w-4 h-4 mb-0.5" />
          <span className="text-[9px] tracking-tight">Sèries</span>
        </button>

        {/* 4. Pel·lícules */}
        <button
          id="mobile-tab-movies"
          onClick={() => onNavigate('movies')}
          className={`flex flex-col items-center justify-center py-1.5 px-1 rounded-xl transition-all ${
            currentView === 'movies' 
              ? 'text-cyan-400 font-bold scale-105' 
              : 'text-slate-400 hover:text-slate-200'
          }`}
        >
          <Film className="w-4 h-4 mb-0.5" />
          <span className="text-[9px] tracking-tight">Pel·lis</span>
        </button>

        {/* 5. IPTV */}
        <button
          id="mobile-tab-iptv"
          onClick={() => onNavigate('iptv')}
          className={`flex flex-col items-center justify-center py-1.5 px-1 rounded-xl transition-all ${
            currentView === 'iptv' 
              ? 'text-red-400 font-bold scale-105' 
              : 'text-slate-400 hover:text-slate-200'
          }`}
        >
          <Radio className="w-4 h-4 mb-0.5 text-red-400" />
          <span className="text-[9px] tracking-tight">IPTV</span>
        </button>

        {/* 6. Cerca */}
        <button
          id="mobile-tab-search"
          onClick={onOpenSearch}
          className="flex flex-col items-center justify-center py-1.5 px-1 rounded-xl text-slate-400 hover:text-white transition-all"
        >
          <Search className="w-4 h-4 mb-0.5 text-sky-400" />
          <span className="text-[9px] tracking-tight">Cerca</span>
        </button>

      </div>
    </div>
  );
};
